export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    count: '2,400 items',
    imageSeq: 'cat-shoes-01',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    count: '1,850 items',
    imageSeq: 'cat-hoodies-01',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    count: '3,200 items',
    imageSeq: 'cat-tshirts-01',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    count: '1,620 items',
    imageSeq: 'cat-jackets-01',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    count: '2,100 items',
    imageSeq: 'cat-pants-01',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    count: '980 items',
    imageSeq: 'cat-headwear-01',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    count: '750 items',
    imageSeq: 'cat-sets-01',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    count: '1,340 items',
    imageSeq: 'cat-underwear-01',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    count: '890 items',
    imageSeq: 'cat-jersey-01',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    count: '2,750 items',
    imageSeq: 'cat-accessories-01',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    count: '1,560 items',
    imageSeq: 'cat-bags-01',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    count: '620 items',
    imageSeq: 'cat-belts-01',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    count: '430 items',
    imageSeq: 'cat-perfumes-01',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    count: '1,180 items',
    imageSeq: 'cat-other-01',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com/';